import { useState, useEffect } from 'react'
import { getBanksAPI } from '../services/banks'

function UseBanks() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getBanksAPI()
      if (!result) return

      const newData = result.result.map((d, i) => {
        return { value: d.id, label: d.bank }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseBanks
